import React from 'react';
import ProjectSlider from './Sliders/ProjectSlider';

const More = () => (
  <div className="body_container">
    <div className="divider" />
    <ProjectSlider section="web" />
    <ProjectSlider section="3d" />
    <ProjectSlider section="misc" />
  </div>
);

export default More;



// WEBPACK FOOTER //
// ./src/components/More.js